import { AbstractCameraRegistry } from './AbstractCameraRegistry';

export const CameraRegistry = AbstractCameraRegistry;
